<div class="p-4 overflow-auto max-h-[85vh]">

  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Counters</h2>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-fluid" *ngIf="!initialLoading">

    <!-- Registration Fieldset -->
    <p-fieldset legend="Registration Details " class="mt-3">
      <div class="flex flex-row gap-3 w-full">
        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="registration_id">Registration ID</label>
          <input type="number" id="registration_id" pInputText formControlName="registration_id" />
        </div>

        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="registration_id_prefix">Registration Prefix</label>
          <input type="text" id="registration_id_prefix" pInputText formControlName="registration_id_prefix" />
        </div>

        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="registration_id_length">Registration ID Length</label>
          <input type="number" id="registration_id_length" pInputText formControlName="registration_id_length" />
        </div>
      </div>
    </p-fieldset>

    <!-- Application Fieldset -->
    <p-fieldset legend="Application Details" class="mt-3">
      <div class="flex flex-row gap-3 w-full">
        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="application_number">Application Number</label>
          <input type="number" id="application_number" pInputText formControlName="application_number" />
        </div>

        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="application_number_prefix">Application Prefix</label>
          <input type="text" id="application_number_prefix" pInputText formControlName="application_number_prefix" />
        </div>

        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="application_number_length">Application Number Length</label>
          <input type="number" id="application_number_length" pInputText formControlName="application_number_length" />
        </div>
      </div>
    </p-fieldset>


    <!-- ticket fieldset -->
    <p-fieldset legend="Ticket Details" class="mt-3">
      <div class="flex flex-row gap-3 w-full">
        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="ticket_id">Ticket Number</label>
          <input type="number" id="ticket_id" pInputText formControlName="ticket_id" />
        </div>

        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="ticket_id_prefix">Ticket Prefix</label>
          <input type="text" id="ticket_id_prefix" pInputText formControlName="ticket_id_prefix" />
        </div>

        <div class="p-field flex flex-col gap-2 flex-1">
          <label for="ticket_id_length">Ticket Number Length</label>
          <input type="number" id="ticket_id_length" pInputText formControlName="ticket_id_length" />
        </div>
      </div>
    </p-fieldset>
    <p-button type="submit" label="Submit"
    [loading]="loading"
    class="mt-4 flex flex-end justify-end" [disabled]="form.invalid || loading" />
  </form>

  <div *ngIf="initialLoading" class="flex justify-center items-center h-full min-h-[75vh]">
    <p-progressSpinner></p-progressSpinner>
  </div>

</div>